// extracted by mini-css-extract-plugin
module.exports = {"container":"FooterPartners_container__RW8hj","header":"FooterPartners_header__mSFc_","title":"FooterPartners_title__LOdmQ","logo":"FooterPartners_logo__aG4yN"};